import {
  createFrontendPlugin,
  PageBlueprint,
  SubPageBlueprint,
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { adminApiRef, AdminApiClient } from './apis';
import { rootRouteRef } from './routes';
import { GroupIcon } from '@backstage/core-components';

const adminApi = ApiBlueprint.make({
  name: 'adminApi',
  params: defineParams =>
    defineParams({
      api: adminApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AdminApiClient({ discoveryApi, fetchApi }),
    }),
});

export const page = PageBlueprint.make({
  params: {
    path: '/admin',
    routeRef: rootRouteRef,
    title: 'Admin',
  },
});

export const projectsAdminPageTabPage = SubPageBlueprint.make({
  name: 'projectsAdminPageTabPage',
  params: {
    path: 'projects',
    title: 'Projects',
    loader: () =>
      import('./components/Admin').then(m => <m.ProjectsAdminPageTab />),
  },
});

export const usersAdminPageTabPage = SubPageBlueprint.make({
  name: 'usersAdminPageTabPage',
  params: {
    path: 'users',
    title: 'Users',
    loader: () =>
      import('./components/Admin').then(m => <m.UsersAdminPageTab />),
  },
});

export const groupsAdminPageTabPage = SubPageBlueprint.make({
  name: 'groupsAdminPageTabPage',
  params: {
    path: 'groups',
    title: 'Groups',
    loader: () =>
      import('./components/Admin').then(m => <m.GroupsAdminPageTab />),
  },
});

export const devopsAdminPlugin = createFrontendPlugin({
  pluginId: 'devops-admin',
  icon: <GroupIcon fontSize="inherit" />,
  extensions: [
    adminApi,
    page,
    projectsAdminPageTabPage,
    usersAdminPageTabPage,
    groupsAdminPageTabPage,
  ],
  routes: {
    root: rootRouteRef,
  },
});
